const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Despesas/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Despesas/Search')

export default [
  {
    path: 'despesas/create',
    name: 'DespesasCreate',
    component: Single,
    meta: {
      title: 'Adicionar Despesa',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'despesas',
        action: 'create'
      }
    }
  },
  {
    path: 'despesas/:id',
    name: 'DespesasEdit',
    component: Single,
    meta: {
      title: 'Editar Despesa',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'despesas',
        action: 'read'
      }
    }
  },
  {
    path: 'despesas',
    name: 'DespesasSearch',
    component: Search,
    meta: {
      title: 'Despesas',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'despesas',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/despesas.js